// app-pages/AdminPage/ModelShowcaseUpload.tsx
"use client";
import React, { useState } from "react";
import { Flex, Text, Button, Input, Select } from "@chakra-ui/react";
import { useGetAllModels, useUploadImages, useUpdateFeatured } from "queries";

export const ModelShowcaseUpload = () => {
  const { data: modelsData } = useGetAllModels(false, 50, []);
  const [selectedModelUsername, setSelectedModelUsername] = useState("");
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const uploadMutation = useUploadImages();
  const [isFeatured, setIsFeatured] = useState(false);
  const updateFeaturedStatusMutation = useUpdateFeatured();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFiles(Array.from(event.target.files));
    }
  };

  const handleModelChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedModelUsername(event.target.value);
  };

  const handleFeaturedChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsFeatured(event.target.value === "true");
  };

  const handleUpdateFeaturedStatus = async () => {
    if (!selectedModelUsername) {
      alert("Please select a model.");
      return;
    }

    await updateFeaturedStatusMutation.mutateAsync({
      username: selectedModelUsername,
      featured: isFeatured,
    });
  };

  const handleSubmit = async () => {
    if (!selectedModelUsername || selectedFiles.length === 0) {
      alert("Please select a model and images to upload.");
      return;
    }

    await uploadMutation.mutateAsync({
      username: selectedModelUsername,
      images: selectedFiles,
    });
  };

  return (
    <Flex direction="column" gap="4">
      <Text>Choose a model to either upload images or change featured status</Text>
      <Select
        placeholder="Select a model"
        onChange={handleModelChange}
        value={selectedModelUsername}
      >
        {modelsData?.pages.map((page) =>
          (page as any).models.map((model: any) => (
            <option style={{ color: "black" }} key={model.username} value={model.username}>
              {model.username}
            </option>
          ))
        )}
      </Select>
      <Text mt="30px">Upload showcase photos</Text>

      <Input type="file" multiple onChange={handleFileChange} />
      <Button onClick={handleSubmit}>Upload Images</Button>
      {uploadMutation.isError && <Text color="red.500">Error uploading images</Text>}
      {uploadMutation.isSuccess && <Text color="green.500">Images uploaded successfully!</Text>}

      <Text mt="20px">Feature a model</Text>
      <Select placeholder="Featured status" onChange={handleFeaturedChange}>
        <option style={{ color: "black" }} value="true">
          True
        </option>
        <option style={{ color: "black" }} value="false">
          False
        </option>
      </Select>
      <Button onClick={handleUpdateFeaturedStatus}>Update Featured Status</Button>
      {updateFeaturedStatusMutation.isError && (
        <Text color="red.500">Error updating featured status</Text>
      )}
      {updateFeaturedStatusMutation.isSuccess && (
        <Text color="green.500">Featured status updated successfully!</Text>
      )}
    </Flex>
  );
};

export default ModelShowcaseUpload;
